import { FC, ReactNode } from "react";
import { Provider } from "react-redux";
import { store } from "redux/store";

export const ReduxProvider: FC<{ children: ReactNode }> = ({ children }) => (
  <Provider store={store}> {children} </Provider>
);
